import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import AdminNavbar from 'components/argonTemplate/Navbars/AdminNavbar';
import AdminFooter from 'components/argonTemplate/Footers/AdminFooter';
import Sidebar from 'components/argonTemplate/Sidebar/Sidebar';
import Logo from 'assets/img/brand/postFashionLogo.png';

const Admin = (props: any) => {
  const [sidenavOpen, setSidenavOpen] = useState<boolean>(true);

  useEffect(() => {
    document.body.classList.remove('bg-default');
  }, []);

  const toggleSidenav = () => {
    if (document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
    } else {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
    }
    setSidenavOpen((prevSidenavOpen) => !prevSidenavOpen);
  };

  return (
    <>
      <Sidebar
        {...props}
        logo={{
          innerLink: '/dashboard',
          imgSrc: Logo,
          imgAlt: '...',
        }}
        sidenavOpen={sidenavOpen}
        toggleSidenav={toggleSidenav}
      />
      <div className="main-content">
        <AdminNavbar />
        {props.children}
        <Container fluid>
          <AdminFooter />
        </Container>
        {sidenavOpen ? (
          <div
            aria-label="backdrop"
            className="backdrop d-xl-none"
            onClick={toggleSidenav}
            onKeyDown={toggleSidenav}
            role="button"
            tabIndex={0}
          />
        ) : null}
      </div>
    </>
  );
};

export default Admin;
